import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sdc-app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent {
    today: number = Date.now();
}
